







import MP3 from "@/assets/source/order_new.wav";
import { Vue, Component, Ref } from "vue-property-decorator";
import { Getter } from "vuex-class";
import store from "../../store/index";
@Component({
  name: "Audio"
})
export default class IVideo extends Vue {
  public get audioSrc(): string {
    return MP3;
  }

  public get isPc(): boolean {
    let ua = navigator.userAgent,
      isAndroid = /(?:Android)/.test(ua),
      isFireFox = /(?:Firefox)/.test(ua),
      isChrome = /(?:Chrome|CriOS)/.test(ua),
      isTablet =
        /(?:iPad|PlayBook)/.test(ua) ||
        (isAndroid && !/(?:Mobile)/.test(ua)) ||
        (isFireFox && /(?:Tablet)/.test(ua)),
      isPhone = /(?:iPhone)/.test(ua) && !isTablet,
      isPc = !isPhone && !isAndroid && !isTablet;
    return isPc;
  }

  public get openInBrowser(): boolean {
    return store.state.openInBrowser;
  }

  public get isShowAudioBtn(): boolean {
    return this.isPc || this.openInBrowser;
  }

  play() {
    let audio = this.$refs.audio as Element;
    audio.play();
  }
}
